const interestMatrix = I18n.t(`calculators.interest_matrix.fixed_reverting_rate`);

function getFixedRevertingRate(lvr, objective) {

  return interestMatrix[objective][lvr]
}

export default getFixedRevertingRate
